import { Validator } from 'vee-validate';

class Validation {
    static init() {
        Validator.localize('en', this.getCustomErrorMessages());
    }
    static getCustomErrorMessages() {
        return {
            custom: {

            }
        }
    }
}

export default Validation;
